import { Button } from "primereact/button";
import { Message } from "primereact/message";
import React from "react";
import styled from "styled-components";

interface IErrorMessageProps {
  error: any;
  onRetry: () => void;
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
`;

/**
 * ErrorMessage component - Displays error message with retry button
 */
export function ErrorMessage({ error, onRetry }: IErrorMessageProps) {
  // Extract error message from various error formats
  const errorMessage =
    error?.data?.message ||
    error?.message ||
    "An error occurred while fetching precalculated allowables data";

  return (
    <ErrorContainer>
      <Message severity="error" text={errorMessage} style={{ width: "100%" }} />
      <Button
        label="Retry"
        icon="pi pi-refresh"
        onClick={onRetry}
        className="p-button-outlined"
      />
    </ErrorContainer>
  );
}
